<script>
import APIMemberships from '@school/services/API/Memberships';

export default {
  i18n: {
    messages: {
      fr: {
        delete_account: 'Suppression du compte',
        delete_account_warning: 'La suppression de votre compte est définitive.',
        delete_button: 'Supprimer mon compte',
        confirm_deletion: 'Confirmez la suppression de votre compte en renseignant votre mot de passe.',
        ok: 'Ok !',
        cancel: 'Annuler',
        warning: 'Attention',
        continue: 'Continuer',
        active_membership_block: 'Vous devez d\'abord mettre fin à votre abonnement avant de supprimer votre compte.',
        cancel_at_period_end_warning: 'Vous avez un abonnement programmé pour annulation. La suppression de votre compte entraînera la suppression immédiate de votre abonnement et de tous vos accès. Cette action est irréversible. Souhaitez-vous continuer ?',
      },
      en: {
        delete_account: 'Delete Account',
        delete_account_warning: 'Caution : this action is permanent.',
        delete_button: 'Delete my account',
        confirm_deletion: 'Enter your password to confirm the deletion of your account.',
        ok: 'Ok!',
        cancel: 'Cancel',
        warning: 'Warning',
        continue: 'Continue',
        active_membership_block: 'Please cancel your active membership before deleting your account.',
        cancel_at_period_end_warning: 'You have a membership scheduled for cancellation. Deleting your account will immediately cancel your membership and remove all access. This action is irreversible. Do you want to continue?',
      },
    },
  },
  methods: {
    async deleteAccount() {
      const loader = this.$buefy.loading.open();
      try {
        const { data } = await APIMemberships.getMyMemberships();

        let memberships;
        if (Array.isArray(data?.data)) {
          memberships = data.data;
        } else if (data?.data?.data && Array.isArray(data.data.data)) {
          memberships = data.data.data;
        } else {
          memberships = Array.isArray(data) ? data : [];
        }

        const activeMemberships = memberships.filter((m) => m.status === 'active' && m.current_period_end && new Date(m.current_period_end) > new Date());
        const cancelAtPeriodEndMemberships = memberships.filter((m) => m.status === 'cancel_at_period_end' && m.current_period_end && new Date(m.current_period_end) > new Date());

        if (activeMemberships.length > 0) {
          this.$buefy.toast.open({
            message: this.$t('active_membership_block'),
            type: 'is-danger',
            duration: 5000,
          });
          loader.close();
          return;
        }

        if (cancelAtPeriodEndMemberships.length > 0) {
          loader.close();
          this.$buefy.dialog.confirm({
            title: this.$t('warning'),
            message: this.$t('cancel_at_period_end_warning'),
            type: 'is-warning',
            confirmText: this.$t('continue'),
            cancelText: this.$t('cancel'),
            onConfirm: () => {
              this.proceedWithDeletion();
            },
          });
          return;
        }
      } catch (error) {
        this.$errorHandlers.axios(error);
        loader.close();
        return;
      }
      loader.close();
      this.proceedWithDeletion();
    },
    proceedWithDeletion() {
      this.$buefy.dialog.prompt({
        message: this.$t('confirm_deletion'),
        type: 'is-danger',
        inputAttrs: { type: 'password' },
        confirmText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        closeOnConfirm: false,
        onConfirm: ((password, { close }) => {
          const loader = this.$buefy.loading.open();
          this.$store.dispatch('auth/delete', { password })
            .then(() => {
              this.$showMessage.success();
              close();
            })
            .catch((error) => this.$errorHandlers.axios(error))
            .finally(() => loader.close());
        }),
      });
    },
  },
};
</script>

<template>
  <div class="box is-flex is-justify-content-space-between is-align-items-center">
    <div class="content">
      <h2 class="is-size-6">
        {{ $t('delete_account') }}
      </h2>
      <p>
        {{ $t('delete_account_warning') }}
      </p>
    </div>
    <b-button type="is-danger" outlined @click="deleteAccount">
      {{ $t('delete_button') }}
    </b-button>
  </div>
</template>
